import type { Organization } from "../entities/Organization"
import type { AppRole } from "@/modules/auth/constants/app-role"

export function getOrganizationRoles(organization: Organization | null | undefined): AppRole[] {
  if (organization?.userRoles?.length) return organization.userRoles as AppRole[]
  return organization?.userRole ? [organization.userRole as AppRole] : []
}
